import { Col, Form, Row, Select, Spin } from "antd";
import React, { useState, useEffect, useMemo } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Table from "../../atoms/Table";
import ClientWrapStyle from "./ClientWrapStyle";
import { DropdownCheckBox } from "../../atoms/UIDropdown/Dropdown";
import styled from "styled-components";
import moment from "moment";
import { uniqBy } from "lodash";
import { connect, useDispatch, useSelector } from "react-redux";
import ViewMore from "../../organisms/ViewMore";
import EditOutlined from "@ant-design/icons/EditOutlined";
import {
  getCRMManagingOfficeList,
  getFilters,
  getStatusCodes,
  getMenuList,
  getUserRoleId,
} from "redux/selectors";
import { setFilter } from "redux/actions";
import { hasClientPermission } from "./clientPermission";

const StyledWrap = styled.div`
  .ant-table-tbody > tr > td {
    font-weight: 400 !important;
  }
`;

const fontStyle = { color: "#636980" };

const FV = "@OData.Community.Display.V1.FormattedValue";
const OFFICE = `bdo_managingoffice${FV}`;
const OWNER = `_ownerid_value${FV}`;
const STATUS = `statuscode${FV}`;
const COB = `bdo_status${FV}`;
const REL_MANAGER = `_bdo_relationship_value${FV}`;

// Zambia (Africa/Lusaka) = Central Africa Time, UTC+2, no daylight saving
const ZAMBIA_UTC_OFFSET_MINUTES = 120;
const DATE_FORMAT = "DD/MM/YYYY hh:mma";

// Dataverse returns UTC timestamps; parse as UTC, then display in Zambia time
const formatZambiaTime = (value, format = DATE_FORMAT) => {
  if (!value) return "-";
  const m = moment.utc(value);
  return m.isValid() ? m.utcOffset(ZAMBIA_UTC_OFFSET_MINUTES).format(format) : "-";
};

// Null-safe string comparison for table sorters
const cmp = (a, b) => (a ?? "").toString().localeCompare((b ?? "").toString());

// Null-safe date comparison for table sorters
const cmpDate = (a, b) => (a ? moment.utc(a).valueOf() : 0) - (b ? moment.utc(b).valueOf() : 0);

// Owner is not returned by the API, so fall back to the creator
const getOwner = (item) => item?.[OWNER] ?? item?.createdByName;

const Active = ({
  clientList,
  showLoader,
  loader,
  onSendData,
  totalFilteredClientCount,
}) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const filters = useSelector(getFilters);
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  const menuName = "client";

  // Menu permissions for the logged-in user's role
  const Menulist = menuList?.[userRoleId] || Object.values(menuList || {})[0];

  // Edit permission from the "client" or "ownclient" menu
  const hasClientEditPermission = hasClientPermission(Menulist, "edit");

  useEffect(() => {
    if (clientList && clientList.length > 0) {
      onSendData?.(clientList);
    }
  }, [clientList]);

  console.log(Menulist, "Menulist")

  const goToDetails = (bdoId) =>
    // state is passed flat; "from" remembers which list we came from
    history.push(`/client-details/${bdoId}`, {
      extraData: clientList,
      from: location.pathname,
    });

  const columns = [
    {
      title: "Registered Name",
      dataIndex: "name",
      key: "name",
      className: " approved",
      render: (name) => (name ? <ViewMore value={name} count={20} /> : "-"),
      sorter: (a, b) => cmp(a?.name, b?.name),
    },
    {
      title: "Managing Office",
      dataIndex: OFFICE,
      key: OFFICE,
      render: (v) => v || "-",
      sorter: (a, b) => cmp(a?.[OFFICE], b?.[OFFICE]),
    },
    {
      title: "Client ID",
      dataIndex: "bdo_id",
      key: "bdo_id",
      render: (bdo_id) => bdo_id || "-",
      sorter: (a, b) => cmp(a?.bdo_id, b?.bdo_id),
    },
    {
      title: "Owner",
      key: "owner",
      render: (_, record) => getOwner(record) || "-",
      sorter: (a, b) => cmp(getOwner(a), getOwner(b)),
    },
    {
      title: "Created On",
      dataIndex: "createdon",
      key: "createdon",
      sorter: (a, b) => cmpDate(a?.createdon, b?.createdon),
      render: (createdon) => formatZambiaTime(createdon),
    },
    {
      title: "Email",
      dataIndex: "emailaddress1",
      key: "emailaddress1",
      className: "approved",
      sorter: (a, b) => cmp(a?.emailaddress1, b?.emailaddress1),
      render: (email) => (email ? email.toLowerCase() : "-"),
    },
    {
      title: "Status Reason",
      dataIndex: STATUS,
      key: STATUS,
      render: (v) => v || "-",
      sorter: (a, b) => cmp(a?.[STATUS], b?.[STATUS]),
    },
    {
      title: "COB Form Status",
      dataIndex: COB,
      key: COB,
      render: (v) => v || "-",
      sorter: (a, b) => cmp(a?.[COB], b?.[COB]),
    },
    {
      title: "Modified On",
      dataIndex: "modifiedon",
      key: "modifiedon",
      render: (modifiedon) => formatZambiaTime(modifiedon),
      sorter: (a, b) => cmpDate(a?.modifiedon, b?.modifiedon),
    },
    // Action column (edit icon) only for users with client edit permission
    ...(hasClientEditPermission
      ? [
        {
          title: "Action",
          key: "action",
          fixed: "right",
          render: (_, record) => (
            <EditOutlined
              onClick={(e) => {
                e.stopPropagation();
                history.push(`/edit-client/${record.bdo_id}`, {
                  from: location.pathname,
                });
              }}
            />
          ),
        },
      ]
      : []),
  ];

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    dispatch(setFilter(menuName, "name", values.name || []));
    dispatch(setFilter(menuName, "managingoffice", values.managingoffice || []));
    dispatch(setFilter(menuName, "status", values.status || []));
    dispatch(setFilter(menuName, "owner", values.owner || []));
    dispatch(
      setFilter(menuName, "relationship_manager", values.relationship_manager || [])
    );
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 20,
    showSizeChanger: false,
  };

  const buildOptions = (values) =>
    uniqBy(
      (values || []).filter(Boolean).map((value) => ({ label: value, value })),
      "value"
    );

  const uniqueName = useMemo(
    () => buildOptions(clientList?.map((i) => i?.name)),
    [clientList]
  );
  const uniquemanagingOffice = useMemo(
    () => buildOptions(clientList?.map((i) => i?.[OFFICE])),
    [clientList]
  );
  const uniqueStatus = useMemo(
    () => buildOptions(clientList?.map((i) => i?.[STATUS])),
    [clientList]
  );
  const uniqueownervalue = useMemo(
    () => buildOptions(clientList?.map((i) => getOwner(i))),
    [clientList]
  );
  const uniquerelationshipmanagervalue = useMemo(
    () => buildOptions(clientList?.map((i) => i?.[REL_MANAGER])),
    [clientList]
  );

  const getFilteredData = () => {
    const name = form.getFieldValue("name") || [];
    const managingoffice = form.getFieldValue("managingoffice") || [];
    const status = form.getFieldValue("status") || [];
    const owner = form.getFieldValue("owner") || [];
    const relationshipManager = form.getFieldValue("relationship_manager") || [];

    if (
      !name.length &&
      !managingoffice.length &&
      !status.length &&
      !owner.length &&
      !relationshipManager.length
    ) {
      return clientList;
    }

    return clientList?.filter(
      (item) =>
        (!name.length || name.includes(item?.name)) &&
        (!managingoffice.length || managingoffice.includes(item?.[OFFICE])) &&
        (!status.length || status.includes(item?.[STATUS])) &&
        (!owner.length || owner.includes(getOwner(item))) &&
        (!relationshipManager.length ||
          relationshipManager.includes(item?.[REL_MANAGER]))
    );
  };

  const filteredCount = clientList?.length || totalFilteredClientCount || 0;

  return (
    <ClientWrapStyle>
      <Form form={form} onValuesChange={handleFormChange} component={false}>
        <Row gutter={[12, 12]} className="mb-2">
          <Col xs={24} sm={12} md={8} lg={5} xl={5}>
            <DropdownCheckBox name="name" label="Client Name" options={uniqueName} form={form} handleFormChange={handleFormChange} />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5} xl={5}>
            <DropdownCheckBox name="managingoffice" label="Managing Office" options={uniquemanagingOffice} form={form} handleFormChange={handleFormChange} />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5} xl={5}>
            <DropdownCheckBox name="status" label="Status" options={uniqueStatus} form={form} handleFormChange={handleFormChange} />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5} xl={5}>
            <DropdownCheckBox name="owner" label="Owner" options={uniqueownervalue} form={form} handleFormChange={handleFormChange} />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5} xl={5}>
            <DropdownCheckBox name="relationship_manager" label="Relationship Manager" options={uniquerelationshipmanagervalue} form={form} handleFormChange={handleFormChange} />
          </Col>
        </Row>
      </Form>

      <div className="people_font_style" style={{ marginTop: "1rem" }}>
        Total Clients: {filteredCount}
      </div>

      <Spin spinning={showLoader}>
        <div>
          <Table
            columns={columns}
            rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
            rowKey="bdo_id"
            dataSource={getFilteredData()?.map((client) => ({
              ...client,
              "Client Name": (
                <Link to={`/client-details/${client?.bdo_id}`} style={fontStyle}>
                  {client?.bdo_id}
                </Link>
              ),
            }))}
            onRow={(record) => ({
              onClick: (event) => {
                event.stopPropagation();
                goToDetails(record.bdo_id);
              },
            })}
            pagination={paginationOptions}
            footer={
              !showLoader
                ? () =>
                  loader && !showLoader ? (
                    <div style={{ textAlign: "center" }}>
                      <Spin spinning={loader} />
                    </div>
                  ) : null
                : false
            }
          />
        </div>
      </Spin>
    </ClientWrapStyle>
  );
};

const mapStateToProps = (state) => ({
  statusCodes: getStatusCodes(state),
});

export default connect(mapStateToProps, null)(Active);